module.exports = __webpack_public_path__ + "img/sr.09530b62.png";